import type { IconData } from '@stacksjs/iconify-core'

export const bd1x1: IconData = {
  "body": "<path fill=\"#006a4e\" d=\"M0 0h512v512H0z\"/><circle cx=\"230\" cy=\"256\" r=\"170.7\" fill=\"#f42a41\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default bd1x1
